import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { StorageService } from './storage.service';

@Injectable()
export class AlphaNumericValidationService {
  isArabic!:boolean;
  constructor(private storageService: StorageService) { 
    this.isArabic = this.storageService.getSessionStorageData('isArabic');
  }

    checkAlphaNumericValue(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            let regex = new RegExp("^([a-zA-Z0-9 ]+)$");
            let onlyalphaNumeric;
            if (regex.test(control.value)) {
              onlyalphaNumeric = true;
            }
            let errMsg;
            if(this.isArabic) {
              errMsg = "يسمح فقط باستخدام الأحرف أو الأرقام";
            } else  {
              errMsg = 'Only letters or numbers are allowed';
            }
          return onlyalphaNumeric ? null : {alphanumeric: {errorMsg : errMsg}};
        };
      }
      // checkSlashValue(): ValidatorFn {
      //   console.log('check slash');
      //   return (control: AbstractControl): ValidationErrors | null => {
      //       let isSlash;
      //       if (control.value.includes(';') || control.value.includes('\\')) {
      //         isSlash = true;
      //       }
      //       let errMsg;
      //       if(this.isArabic) {
      //         errMsg = "؛ و \ غير مسموح بها";
      //       } else  {
      //         errMsg = "; and \ are not allowed";
      //       }
      //     return isSlash ? null : {checkslash: {errorMsg : errMsg}};
      //   };
      // }
}
